import styled from 'styled-components';

export const EmptyStateContentStyled = styled.div`
  width: 100%;
  max-width: 480px;
`;
